import { IAddress } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export type CreateRegisteredAgentBody = {
  name: string;
  address: IAddress;
};

export async function createRegisteredAgent(
  body: CreateRegisteredAgentBody,
  token: string
) {
  const response = await fetcher(
    `registeredAgent/`,
    {
      method: 'POST',
      body,
    },
    token
  );

  return response;
}
